<div class="p-4">
    <breadcrumb [items]="breadcrumb"></breadcrumb>
    <mat-card>
        <mat-card-content>
            <div class="d-flex align-items-end mb-3">
                <h1 class="fs-3 fw-light mb-0">Relatório de Aferições</h1>
                <button mat-icon-button color="primary" class="d-print-none btn-sm ms-auto" (click)="toggleFilters = !toggleFilters">
                    <mat-icon>tune</mat-icon>
                </button>            
            </div>

            <!-- FILTROS -->
            <ng-collapse [toggle]="toggleFilters" >
                <div class="border-top px-1 py-3">
                    <div class="row align-items-end">
                        <div class="col-12 col-md-6">
                            <select-beneficiaria 
                                [(ngModel)]="filters.beneficiaria"
                                (beneficiariaChange)="setBeneficiaria($event)">
                            </select-beneficiaria>                        
                        </div>
                        <div class="col-12 col-md-6">
                            <ng-select name="contrato" [items]="contratos" bindValue="id" bindLabel="nome" placeholder="Contrato"
                                [searchFn]="searchFn" [(ngModel)]="filters.contrato" [compareWith]="compareWith">
                            </ng-select>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="d-flex">
                                <mat-form-field class="flex-fill me-2">
                                    <mat-label>Inicio</mat-label>
                                    <input matInput [matDatepicker]="dataInicio" name="inicio" #inicio="ngModel"
                                        autocomplete="off" [(ngModel)]="filters.dataInicio">
                                    <mat-datepicker-toggle matIconSuffix [for]="dataInicio"></mat-datepicker-toggle>
                                    <mat-datepicker #dataInicio></mat-datepicker>
                                </mat-form-field>
                                <mat-form-field class="flex-fill">
                                    <mat-label>Fim</mat-label>
                                    <input matInput [matDatepicker]="dataFim" name="fim" #fim="ngModel" autocomplete="off"
                                        [(ngModel)]="filters.dataFim">
                                    <mat-datepicker-toggle matIconSuffix [for]="dataFim"></mat-datepicker-toggle>
                                    <mat-datepicker #dataFim></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            
                        </div>
                        <div class="col-12 col-md-2 mx-auto text-center">
                            <a href="javascript:void(0)" class="text-decoration-none" (click)="limparFiltros()">Limpar filtros</a>
                        </div>
                        <div class="col-12 col-md-2 mx-auto">
                            <button mat-flat-button color="accent" class="w-100" (click)="search()">FILTRAR</button>
                        </div>
                    </div>
                </div>
            </ng-collapse>
                  
            <ng-container *ngIf="totals">
                <mat-divider class="my-3"></mat-divider>

                <!-- Resumo dos filtros aplicados -->
                <div class="row g-3 mb-3 align-items-start">
                    <div class="col-12">
                        <span class="fw-bold fs-7 opacity-50 text-uppercase">Filtros aplicados</span>
                    </div>
                    <div class="col-auto" *ngIf="beneficiariaPesquisada">
                        <span class="fw-bold fs-7 opacity-50">BENEFICIÁRIA</span>
                        <div class="lh-sm fw-semibold">{{ beneficiariaPesquisada }}</div>
                    </div>
                    <div class="col-auto" *ngIf="contratoPesquisado">
                        <span class="fw-bold fs-7 opacity-50">CONTRATO</span>
                        <div class="lh-sm fw-semibold">{{ contratoPesquisado }}</div>
                    </div>
                    <div class="col-auto" *ngIf="dataInicioPesquisada || dataFimPesquisada">
                        <span class="fw-bold fs-7 opacity-50">PERÍODO</span>
                        <div class="lh-sm fw-semibold">{{ dataInicioPesquisada }} — {{ dataFimPesquisada }}</div>
                    </div>
                </div>

                <mat-divider class="mb-3"></mat-divider>

                <!-- Cards de totais -->
                <h2 class="fs-6 fw-bold text-muted mb-3">AFERIÇÕES</h2>
                <div class="row g-3 mb-3">
                    <div class="col-12 col-sm-4">
                        <div class="border rounded p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="fw-bold fs-7 opacity-50">PENDENTES DE AFERIÇÃO</span>
                                <mat-icon class="fs-6 text-muted"
                                    matTooltip="DIOs que ainda aguardam aferição no período selecionado">info</mat-icon>
                            </div>
                            <div class="fs-3 fw-bold text-warning">{{ totals.totalPendentesAfericao }}</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <div class="border rounded p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="fw-bold fs-7 opacity-50">AFERIDAS</span>
                                <mat-icon class="fs-6 text-muted"
                                    matTooltip="DIOs que já foram aferidas no período selecionado">info</mat-icon>
                            </div>
                            <div class="fs-3 fw-bold text-success">{{ totals.totalAferidas }}</div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-4">
                        <div class="border rounded p-3">
                            <div class="d-flex justify-content-between align-items-center mb-1">
                                <span class="fw-bold fs-7 opacity-50">TOTAL</span>
                                <mat-icon class="fs-6 text-muted"
                                    matTooltip="Total de DIOs no período selecionado (pendentes + aferidas)">info</mat-icon>
                            </div>
                            <div class="fs-3 fw-bold">{{ totals.totalPendentesAfericao + totals.totalAferidas }}</div>
                        </div>
                    </div>
                </div>
            </ng-container>

            <div style="display: block; width: 600px; height: 400px;">
                <canvas id="myBarChart"></canvas>
            </div>

            <!-- TABLE -->
            <generate-table [dataSource]="dataSource" [columns]="columns" [loading]="loading"
                [total]="pagination.total" [pageSize]="pagination.pageSize" (pageEvent)="search($event)"
            ></generate-table>
        </mat-card-content>
    </mat-card>
</div>
